.summary {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-5);
  text-align: center;
}

.title {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-xl);
}

.exercise {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-muted);
}

.score {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-4xl);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.scored {
  margin: 0;
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-muted);
}

.actions {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  align-items: stretch;
  width: 100%;
  max-width: 320px;
}

@media (min-width: 600px) {
  .actions {
    flex-direction: row;
    justify-content: center;
    max-width: none;
  }
}
